// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9g8wZ","select":"styles_select__1seJX"};